import React from 'react';
import styled from 'styled-components';

import Picture from '../image/CloudFrontPicture';

const SewpatDescription = ({ sewpat }) => {
    const StyledDescription = styled.div`
        float: left;

        & img {
          float: right;
          max-width: 50vw;
          margin: 0 0 1em 1em;
          width: inherit;
          height: inherit;
        }
    `;

    const FlexItem = styled.div`
        max-width: 50vw;
    `;

    const name = `${sewpat.title} by ${sewpat.designer.name}`;

    return (
        <div className='clearfix'>
            <StyledDescription>
                <Picture
                    webp='logo-schnittmuster-berlin.wepb'
                    src='logo-schnittmuster-berlin.png'
                    altText='Logo Schnittmacher Berlin'
                    schnoffle
                    png
                />
                {sewpat.description.content}
            </StyledDescription>
            <meta itemProp='name' content={name} />
            <meta itemProp='description' content={sewpat.summary.content} />
        </div>
    );
};

export default SewpatDescription;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatDescription.js